import Vue from 'vue'
import { VueEditor } from 'vue2-editor'

// Register the component
Vue.component('vue-editor', VueEditor)
